
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vivero",
      function () {
        return require("private-next-pages/vivero/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vivero"])
      });
    }
  